module.exports = __webpack_public_path__ + "static/media/futur.502972f1.otf";